import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./MenuItem.module.scss";
import { v4 } from "uuid";
const MenuItem = ({isSelect,data,index,onClick}) => {
    useEffect(() => {
    }, [])
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${style.item} ${style.selected}` : style.item}>
            <img src={`./assets/menu/tab${isSelect ? "F" : "N"}${index}.png`} />
            <span>{data}</span>
        </div>
    );
}

export default MenuItem;